

























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: { Button }
})
export default class OtherEnrollmentFoundMessage extends Vue {
  userStore = useUserStore();

  @Prop() onProceed;

  doNotProceed () {
    this.userStore.logout();
  }
  proceed () {
    this.onProceed();
  }
}
